/*
 * Project: bellcloud
 * File: packages/i18n/i18nKeyGen.ts
 * Author: SWAN
 * Created: 2026-10-26
 * Description: i18n 키 정의 (타입 안전 + IDE 자동완성 지원)
 * 
 * ⚠️ 이 파일은 자동 생성됩니다. 수동으로 편집하지 마세요.
 * 키를 추가하려면 다국어 JSON 파일을 수정하고 이 스크립트를 다시 실행하세요.
 */

export const i18nKeys = {
  auth: {
    action: 'auth:action',
    active: 'auth:active',
    activeUsers: 'auth:activeUsers',
    add: 'auth:add',
    addAdmin: 'auth:addAdmin',
    addEmail: 'auth:addEmail',
    adminAccountDeleted: 'auth:adminAccountDeleted',
    adminInviteDescription: 'auth:adminInviteDescription',
    adminInviteFailed: 'auth:adminInviteFailed',
    adminInviteSent: 'auth:adminInviteSent',
    adminRegistration: 'auth:adminRegistration',
    admin_required: 'auth:admin_required',
    admin_role_not_assignable: 'auth:admin_role_not_assignable',
    admin_role_super_admin_only: 'auth:admin_role_super_admin_only',
    allowed: 'auth:allowed',
    allowedEmailList: 'auth:allowedEmailList',
    allowed_email_company_name_required: 'auth:allowed_email_company_name_required',
    allowed_email_contract_forbidden_sm: 'auth:allowed_email_contract_forbidden_sm',
    allowed_email_contract_locked: 'auth:allowed_email_contract_locked',
    allowed_email_contract_required: 'auth:allowed_email_contract_required',
    allowed_email_planned_device_limit: 'auth:allowed_email_planned_device_limit',
    allowed_email_planned_duration_months: 'auth:allowed_email_planned_duration_months',
    already_have_account: 'auth:already_have_account',
    api_key_missing: 'auth:api_key_missing',
    api_key_server_not_configured: 'auth:api_key_server_not_configured',
    approve: 'auth:approve',
    approveFailed: 'auth:approveFailed',
    back_to_login: 'auth:back_to_login',
    bellcloud: 'auth:bellcloud',
    cancel: 'auth:cancel',
    cannot_assign_higher_role: 'auth:cannot_assign_higher_role',
    cannot_change_own_role: 'auth:cannot_change_own_role',
    cannot_modify_higher_role: 'auth:cannot_modify_higher_role',
    change_password: 'auth:change_password',
    changing_password: 'auth:changing_password',
    check_your_email_for_reset_link: 'auth:check_your_email_for_reset_link',
    click_to_copy_and_open_email: 'auth:click_to_copy_and_open_email',
    close: 'auth:close',
    companyCount: 'auth:companyCount',
    company_inactive: 'auth:company_inactive',
    company_manager: 'auth:company_manager',
    company_name: 'auth:company_name',
    company_not_found: 'auth:company_not_found',
    company_subscription_expired: 'auth:company_subscription_expired',
    completedActive: 'auth:completedActive',
    completedExpired: 'auth:completedExpired',
    confirmApproveRequest: 'auth:confirmApproveRequest',
    confirmDelete: 'auth:confirmDelete',
    confirmDeleteAdmin: 'auth:confirmDeleteAdmin',
    confirmRejectRequest: 'auth:confirmRejectRequest',
    confirm_delete_used_allowed_email: 'auth:confirm_delete_used_allowed_email',
    confirm_new_password: 'auth:confirm_new_password',
    confirm_password: 'auth:confirm_password',
    confirm_password_hint: 'auth:confirm_password_hint',
    confirm_password_required: 'auth:confirm_password_required',
    contact: 'auth:contact',
    contact_admin_for_email_recovery: 'auth:contact_admin_for_email_recovery',
    contact_company_manager: 'auth:contact_company_manager',
    copy: 'auth:copy',
    creationDate: 'auth:creationDate',
    current_password: 'auth:current_password',
    current_password_incorrect: 'auth:current_password_incorrect',
    delete: 'auth:delete',
    deleteFailed: 'auth:deleteFailed',
    deleted: 'auth:deleted',
    device_configuration: 'auth:device_configuration',
    device_configuration_no_login: 'auth:device_configuration_no_login',
    e_mail: 'auth:e_mail',
    editInvite: 'auth:editInvite',
    editInviteTitle: 'auth:editInviteTitle',
    editMemo: 'auth:editMemo',
    editMemoAndContact: 'auth:editMemoAndContact',
    email: 'auth:email',
    emailAddFailed: 'auth:emailAddFailed',
    emailAdded: 'auth:emailAdded',
    emailSent: 'auth:emailSent',
    emailStatus: 'auth:emailStatus',
    email_already_allowed: 'auth:email_already_allowed',
    email_already_exists: 'auth:email_already_exists',
    email_already_registered: 'auth:email_already_registered',
    email_already_sent: 'auth:email_already_sent',
    email_copied: 'auth:email_copied',
    email_copied_message: 'auth:email_copied_message',
    email_forbidden: 'auth:email_forbidden',
    email_format_correct: 'auth:email_format_correct',
    email_found: 'auth:email_found',
    email_found_success: 'auth:email_found_success',
    email_hint: 'auth:email_hint',
    email_in_use: 'auth:email_in_use',
    email_invalid: 'auth:email_invalid',
    email_not_allowed: 'auth:email_not_allowed',
    email_not_allowed_message: 'auth:email_not_allowed_message',
    email_not_approved: 'auth:email_not_approved',
    email_not_found: 'auth:email_not_found',
    email_pending_approval: 'auth:email_pending_approval',
    email_pending_approval_title: 'auth:email_pending_approval_title',
    email_rejected: 'auth:email_rejected',
    email_required: 'auth:email_required',
    email_send_failed: 'auth:email_send_failed',
    email_send_failed_message: 'auth:email_send_failed_message',
    email_sent: 'auth:email_sent',
    email_verification_sent: 'auth:email_verification_sent',
    email_verified: 'auth:email_verified',
    email_verify_before_signup: 'auth:email_verify_before_signup',
    enterMemo: 'auth:enterMemo',
    enter_company_name: 'auth:enter_company_name',
    enter_current_password: 'auth:enter_current_password',
    enter_email_for_password_reset: 'auth:enter_email_for_password_reset',
    enter_name: 'auth:enter_name',
    enter_new_password: 'auth:enter_new_password',
    find_email: 'auth:find_email',
    forbidden: 'auth:forbidden',
    forgot_password: 'auth:forgot_password',
    get_allowed_emails_success: 'auth:get_allowed_emails_success',
    get_user_list_success: 'auth:get_user_list_success',
    having_trouble_logging_in: 'auth:having_trouble_logging_in',
    hide_password_change: 'auth:hide_password_change',
    inactive: 'auth:inactive',
    input_error: 'auth:input_error',
    invalid_api_key: 'auth:invalid_api_key',
    invalid_authorization_header_format: 'auth:invalid_authorization_header_format',
    invalid_invite_code: 'auth:invalid_invite_code',
    invalid_link: 'auth:invalid_link',
    invalid_reset_token: 'auth:invalid_reset_token',
    invalid_role: 'auth:invalid_role',
    invalid_token: 'auth:invalid_token',
    invalid_value: 'auth:invalid_value',
    invalid_verification_token: 'auth:invalid_verification_token',
    invite_email_sent: 'auth:invite_email_sent',
    inviter_company_mismatch: 'auth:inviter_company_mismatch',
    login: 'auth:login',
    login_failed: 'auth:login_failed',
    login_failed_message: 'auth:login_failed_message',
    login_in_progress: 'auth:login_in_progress',
    login_success: 'auth:login_success',
    logout: 'auth:logout',
    memo: 'auth:memo',
    memoUpdated: 'auth:memoUpdated',
    missing_authorization_header: 'auth:missing_authorization_header',
    missing_token_or_email: 'auth:missing_token_or_email',
    my_profile: 'auth:my_profile',
    name: 'auth:name',
    name_company_required: 'auth:name_company_required',
    name_format_correct: 'auth:name_format_correct',
    name_required: 'auth:name_required',
    name_too_short: 'auth:name_too_short',
    network_error: 'auth:network_error',
    network_error_message: 'auth:network_error_message',
    new_password: 'auth:new_password',
    noEmailsRegistered: 'auth:noEmailsRegistered',
    noUsersRegistered: 'auth:noUsersRegistered',
    no_account_yet: 'auth:no_account_yet',
    no_user_found: 'auth:no_user_found',
    no_user_found_with_phone_and_name: 'auth:no_user_found_with_phone_and_name',
    notSent: 'auth:notSent',
    only_own_account: 'auth:only_own_account',
    only_own_company_user: 'auth:only_own_company_user',
    password: 'auth:password',
    password_change_failed: 'auth:password_change_failed',
    password_changed_success: 'auth:password_changed_success',
    password_complexity_required: 'auth:password_complexity_required',
    password_hint: 'auth:password_hint',
    password_minimum_8_characters: 'auth:password_minimum_8_characters',
    password_mismatch: 'auth:password_mismatch',
    password_mismatch_message: 'auth:password_mismatch_message',
    password_required: 'auth:password_required',
    password_reset_email_sent: 'auth:password_reset_email_sent',
    password_reset_email_sent_description: 'auth:password_reset_email_sent_description',
    password_reset_success: 'auth:password_reset_success',
    password_strength: 'auth:password_strength',
    password_strong: 'auth:password_strong',
    password_weak: 'auth:password_weak',
    password_weak_message: 'auth:password_weak_message',
    passwords_do_not_match: 'auth:passwords_do_not_match',
    pendingRequest: 'auth:pendingRequest',
    peopleCount: 'auth:peopleCount',
    phone: 'auth:phone',
    phone_copied: 'auth:phone_copied',
    phone_copied_message: 'auth:phone_copied_message',
    phone_format_correct: 'auth:phone_format_correct',
    phone_format_incorrect: 'auth:phone_format_incorrect',
    phone_hint: 'auth:phone_hint',
    phone_hint_kr: 'auth:phone_hint_kr',
    phone_hint_us: 'auth:phone_hint_us',
    phone_invalid: 'auth:phone_invalid',
    phone_number: 'auth:phone_number',
    phone_number_required: 'auth:phone_number_required',
    phone_placeholder: 'auth:phone_placeholder',
    phone_required: 'auth:phone_required',
    pleaseEnterCompanyName: 'auth:pleaseEnterCompanyName',
    pleaseEnterEmail: 'auth:pleaseEnterEmail',
    pleaseEnterName: 'auth:pleaseEnterName',
    pleaseEnterPhone: 'auth:pleaseEnterPhone',
    pleaseEnterPlannedDeviceLimit: 'auth:pleaseEnterPlannedDeviceLimit',
    pleaseEnterPlannedDurationMonths: 'auth:pleaseEnterPlannedDurationMonths',
    please_login_again: 'auth:please_login_again',
    rate_limit: 'auth:rate_limit',
    rate_limit_message: 'auth:rate_limit_message',
    redirecting_to_sign_up: 'auth:redirecting_to_sign_up',
    registered: 'auth:registered',
    registrationCompleted: 'auth:registrationCompleted',
    registrationDate: 'auth:registrationDate',
    registrationStatus: 'auth:registrationStatus',
    registration_complete: 'auth:registration_complete',
    registration_failed: 'auth:registration_failed',
    registration_request: 'auth:registration_request',
    registration_request_failed: 'auth:registration_request_failed',
    registration_request_received: 'auth:registration_request_received',
    reject: 'auth:reject',
    rejectFailed: 'auth:rejectFailed',
    rejected: 'auth:rejected',
    remember_me: 'auth:remember_me',
    remember_password: 'auth:remember_password',
    requestApproved: 'auth:requestApproved',
    requestRejected: 'auth:requestRejected',
    request_in_progress: 'auth:request_in_progress',
    request_new_link: 'auth:request_new_link',
    request_not_found: 'auth:request_not_found',
    request_not_pending: 'auth:request_not_pending',
    request_received: 'auth:request_received',
    requested: 'auth:requested',
    requesterInfo: 'auth:requesterInfo',
    required_field: 'auth:required_field',
    reset_password: 'auth:reset_password',
    resetting: 'auth:resetting',
    role: 'auth:role',
    role_badge_company_manager: 'auth:role_badge_company_manager',
    role_badge_site_manager: 'auth:role_badge_site_manager',
    save: 'auth:save',
    send: 'auth:send',
    send_registration_request: 'auth:send_registration_request',
    send_request: 'auth:send_request',
    send_reset_link: 'auth:send_reset_link',
    sending: 'auth:sending',
    server_error: 'auth:server_error',
    server_error_message: 'auth:server_error_message',
    session_takeover_footer: 'auth:session_takeover_footer',
    session_takeover_message: 'auth:session_takeover_message',
    session_takeover_title: 'auth:session_takeover_title',
    sign_up: 'auth:sign_up',
    signing_up: 'auth:signing_up',
    signup_subscription_invite_add_desc: 'auth:signup_subscription_invite_add_desc',
    signup_subscription_invite_email_notice: 'auth:signup_subscription_invite_email_notice',
    site_manager_inviter_must_be_company_manager: 'auth:site_manager_inviter_must_be_company_manager',
    site_not_assigned: 'auth:site_not_assigned',
    site_not_assigned_message: 'auth:site_not_assigned_message',
    support_email: 'auth:support_email',
    terms_agreement: 'auth:terms_agreement',
    token_expired_or_invalid: 'auth:token_expired_or_invalid',
    total: 'auth:total',
    totalAdmins: 'auth:totalAdmins',
    totalUsers: 'auth:totalUsers',
    unknown_error: 'auth:unknown_error',
    unknown_error_message: 'auth:unknown_error_message',
    unregistered: 'auth:unregistered',
    updateFailed: 'auth:updateFailed',
    update_user_role_success: 'auth:update_user_role_success',
    user_inactive: 'auth:user_inactive',
    user_not_found: 'auth:user_not_found',
    user_password_not_match: 'auth:user_password_not_match',
    usersList: 'auth:usersList',
    validating_token: 'auth:validating_token',
    verificationStatus: 'auth:verificationStatus',
    verificationStatusLabel: 'auth:verificationStatusLabel',
    verification_expired: 'auth:verification_expired',
    verification_token_expired: 'auth:verification_token_expired',
    waiting: 'auth:waiting',
    welcome: 'auth:welcome',
    withdraw: 'auth:withdraw',
    withdraw_confirm: 'auth:withdraw_confirm',
    withdraw_success: 'auth:withdraw_success',
    withdraw_warning: 'auth:withdraw_warning',
    you_can_now_login: 'auth:you_can_now_login',
  },
  common: {
    columnVisibility: 'common:columnVisibility',
    datalog: 'common:datalog',
    device_created_date: 'common:device_created_date',
    device_name: 'common:device_name',
    device_status: 'common:device_status',
    disconnect_reason_app_force_closed: 'common:disconnect_reason_app_force_closed',
    disconnect_reason_cloud_disabled: 'common:disconnect_reason_cloud_disabled',
    disconnect_reason_firmware_update: 'common:disconnect_reason_firmware_update',
    disconnect_reason_log_download: 'common:disconnect_reason_log_download',
    disconnect_reason_other: 'common:disconnect_reason_other',
    disconnect_reason_user_disconnect: 'common:disconnect_reason_user_disconnect',
    enterPhoneNumber: 'common:enterPhoneNumber',
    error_unknownError: 'common:error_unknownError',
    extension: 'common:extension',
    filter: 'common:filter',
    hide_password: 'common:hide_password',
    inquiry_cancel: 'common:inquiry_cancel',
    inquiry_desc: 'common:inquiry_desc',
    inquiry_email: 'common:inquiry_email',
    inquiry_email_hint: 'common:inquiry_email_hint',
    inquiry_email_hint_locked: 'common:inquiry_email_hint_locked',
    inquiry_email_placeholder: 'common:inquiry_email_placeholder',
    inquiry_email_required: 'common:inquiry_email_required',
    inquiry_error_message: 'common:inquiry_error_message',
    inquiry_error_title: 'common:inquiry_error_title',
    inquiry_menu: 'common:inquiry_menu',
    inquiry_message: 'common:inquiry_message',
    inquiry_message_placeholder: 'common:inquiry_message_placeholder',
    inquiry_message_required: 'common:inquiry_message_required',
    inquiry_name: 'common:inquiry_name',
    inquiry_name_placeholder: 'common:inquiry_name_placeholder',
    inquiry_sending: 'common:inquiry_sending',
    inquiry_subject: 'common:inquiry_subject',
    inquiry_subject_placeholder: 'common:inquiry_subject_placeholder',
    inquiry_submit: 'common:inquiry_submit',
    inquiry_success_message: 'common:inquiry_success_message',
    inquiry_success_title: 'common:inquiry_success_title',
    inquiry_title: 'common:inquiry_title',
    install_app_android_button: 'common:install_app_android_button',
    install_app_android_description: 'common:install_app_android_description',
    install_app_android_title: 'common:install_app_android_title',
    install_app_close_label: 'common:install_app_close_label',
    install_app_guide_step0: 'common:install_app_guide_step0',
    install_app_guide_step1: 'common:install_app_guide_step1',
    install_app_guide_step2: 'common:install_app_guide_step2',
    install_app_guide_step3: 'common:install_app_guide_step3',
    install_app_guide_step4: 'common:install_app_guide_step4',
    install_app_guide_title: 'common:install_app_guide_title',
    install_app_ios_description: 'common:install_app_ios_description',
    install_app_ios_detail_button: 'common:install_app_ios_detail_button',
    install_app_ios_step_add: 'common:install_app_ios_step_add',
    install_app_ios_step_share: 'common:install_app_ios_step_share',
    install_app_ios_title: 'common:install_app_ios_title',
    internal_server_error: 'common:internal_server_error',
    loading: 'common:loading',
    loading_cancel_download: 'common:loading_cancel_download',
    loading_cancel_warning: 'common:loading_cancel_warning',
    loading_please_wait: 'common:loading_please_wait',
    menu_admin_companies: 'common:menu_admin_companies',
    menu_allowed_emails: 'common:menu_allowed_emails',
    menu_configurator: 'common:menu_configurator',
    menu_dashboard_home: 'common:menu_dashboard_home',
    menu_datalog: 'common:menu_datalog',
    menu_lite: 'common:menu_lite',
    menu_management: 'common:menu_management',
    menu_mini: 'common:menu_mini',
    menu_monitoring_playback: 'common:menu_monitoring_playback',
    menu_monitoring_realtime: 'common:menu_monitoring_realtime',
    menu_system_status: 'common:menu_system_status',
    menu_user_log: 'common:menu_user_log',
    menu_users: 'common:menu_users',
    nav_open_menu: 'common:nav_open_menu',
    push_notification_body_alarm: 'common:push_notification_body_alarm',
    push_notification_body_alarm_end: 'common:push_notification_body_alarm_end',
    push_notification_body_connect: 'common:push_notification_body_connect',
    push_notification_body_device_info: 'common:push_notification_body_device_info',
    push_notification_body_disconnect: 'common:push_notification_body_disconnect',
    push_notification_body_test: 'common:push_notification_body_test',
    push_notification_body_token_expiry: 'common:push_notification_body_token_expiry',
    push_notification_body_warning: 'common:push_notification_body_warning',
    push_notification_not_supported: 'common:push_notification_not_supported',
    push_notification_permission_denied: 'common:push_notification_permission_denied',
    push_notification_permission_granted: 'common:push_notification_permission_granted',
    push_notification_permission_request_failed: 'common:push_notification_permission_request_failed',
    push_notification_title_alarm: 'common:push_notification_title_alarm',
    push_notification_title_alarm_end: 'common:push_notification_title_alarm_end',
    push_notification_title_connect: 'common:push_notification_title_connect',
    push_notification_title_disconnect: 'common:push_notification_title_disconnect',
    push_notification_title_token_expiry: 'common:push_notification_title_token_expiry',
    push_notification_title_warning: 'common:push_notification_title_warning',
    push_notification_type_device_info: 'common:push_notification_type_device_info',
    push_notification_type_test: 'common:push_notification_type_test',
    push_notification_warning_detected: 'common:push_notification_warning_detected',
    search: 'common:search',
    select_device: 'common:select_device',
    select_site: 'common:select_site',
    show_password: 'common:show_password',
    user_log_all: 'common:user_log_all',
    user_log_col_action: 'common:user_log_col_action',
    user_log_col_error: 'common:user_log_col_error',
    user_log_col_feature: 'common:user_log_col_feature',
    user_log_col_message: 'common:user_log_col_message',
    user_log_col_time: 'common:user_log_col_time',
    user_log_col_user: 'common:user_log_col_user',
    user_log_empty: 'common:user_log_empty',
    user_log_from: 'common:user_log_from',
    user_log_no: 'common:user_log_no',
    user_log_refresh: 'common:user_log_refresh',
    user_log_search: 'common:user_log_search',
    user_log_to: 'common:user_log_to',
    user_log_yes: 'common:user_log_yes',
    validation_failed: 'common:validation_failed',
  },
  company: {
    cancel: 'company:cancel',
    close: 'company:close',
    company: 'company:company',
    company_created_at: 'company:company_created_at',
    company_delete: 'company:company_delete',
    company_delete_confirm: 'company:company_delete_confirm',
    company_delete_failed: 'company:company_delete_failed',
    company_delete_success: 'company:company_delete_success',
    company_description: 'company:company_description',
    company_description_placeholder: 'company:company_description_placeholder',
    company_get_failed: 'company:company_get_failed',
    company_info: 'company:company_info',
    company_list: 'company:company_list',
    company_location: 'company:company_location',
    company_location_placeholder: 'company:company_location_placeholder',
    company_manager_edit: 'company:company_manager_edit',
    company_manager_update_success: 'company:company_manager_update_success',
    company_name: 'company:company_name',
    company_name_placeholder: 'company:company_name_placeholder',
    company_name_required: 'company:company_name_required',
    company_row_collapse: 'company:company_row_collapse',
    company_row_manage: 'company:company_row_manage',
    company_row_view_details: 'company:company_row_view_details',
    company_status: 'company:company_status',
    company_telephone: 'company:company_telephone',
    company_update_failed: 'company:company_update_failed',
    company_update_success: 'company:company_update_success',
    confirm: 'company:confirm',
    delete_company_success: 'company:delete_company_success',
    delete_site_manager_success: 'company:delete_site_manager_success',
    delete_type_name_prompt: 'company:delete_type_name_prompt',
    device_no_data: 'company:device_no_data',
    device_reassign: 'company:device_reassign',
    device_reassign_current_site: 'company:device_reassign_current_site',
    device_reassign_description: 'company:device_reassign_description',
    device_reassign_new_site: 'company:device_reassign_new_site',
    device_reassign_select_site: 'company:device_reassign_select_site',
    device_reassign_success: 'company:device_reassign_success',
    device_reassign_title: 'company:device_reassign_title',
    device_serial_number: 'company:device_serial_number',
    device_status: 'company:device_status',
    device_type: 'company:device_type',
    edit: 'company:edit',
    error_admin_no_company: 'company:error_admin_no_company',
    error_company_delete_failed: 'company:error_company_delete_failed',
    error_company_get_failed: 'company:error_company_get_failed',
    error_company_id_required: 'company:error_company_id_required',
    error_company_inactive: 'company:error_company_inactive',
    error_company_manager_get_failed: 'company:error_company_manager_get_failed',
    error_company_not_assigned: 'company:error_company_not_assigned',
    error_company_not_found: 'company:error_company_not_found',
    error_company_update_failed: 'company:error_company_update_failed',
    error_not_site_manager: 'company:error_not_site_manager',
    error_not_your_company_site: 'company:error_not_your_company_site',
    error_not_your_company_site_manager: 'company:error_not_your_company_site_manager',
    error_occurred: 'company:error_occurred',
    error_site_manager_create_failed: 'company:error_site_manager_create_failed',
    error_site_manager_delete_failed: 'company:error_site_manager_delete_failed',
    error_site_manager_get_failed: 'company:error_site_manager_get_failed',
    error_site_manager_invite_email_failed: 'company:error_site_manager_invite_email_failed',
    error_site_manager_not_found: 'company:error_site_manager_not_found',
    error_site_manager_update_failed: 'company:error_site_manager_update_failed',
    error_subscription_device_limit_invalid: 'company:error_subscription_device_limit_invalid',
    error_subscription_end_date_past: 'company:error_subscription_end_date_past',
    error_subscription_end_date_required: 'company:error_subscription_end_date_required',
    error_subscription_no_active: 'company:error_subscription_no_active',
    get_companies_success: 'company:get_companies_success',
    get_site_managers_success: 'company:get_site_managers_success',
    loading: 'company:loading',
    max_devices: 'company:max_devices',
    max_devices_placeholder: 'company:max_devices_placeholder',
    max_devices_update_success: 'company:max_devices_update_success',
    need_admin_role: 'company:need_admin_role',
    need_company_manager_or_admin_role: 'company:need_company_manager_or_admin_role',
    need_site_manager_role: 'company:need_site_manager_role',
    no_permission_create_site: 'company:no_permission_create_site',
    no_permission_delete_site: 'company:no_permission_delete_site',
    no_permission_edit_company: 'company:no_permission_edit_company',
    no_permission_edit_site: 'company:no_permission_edit_site',
    processing: 'company:processing',
    save: 'company:save',
    save_success: 'company:save_success',
    site_action: 'company:site_action',
    site_create: 'company:site_create',
    site_create_new: 'company:site_create_new',
    site_create_success: 'company:site_create_success',
    site_delete: 'company:site_delete',
    site_delete_confirm: 'company:site_delete_confirm',
    site_delete_last_warning: 'company:site_delete_last_warning',
    site_delete_success: 'company:site_delete_success',
    site_device_count: 'company:site_device_count',
    site_edit: 'company:site_edit',
    site_list: 'company:site_list',
    site_location: 'company:site_location',
    site_location_placeholder: 'company:site_location_placeholder',
    site_management: 'company:site_management',
    site_manager: 'company:site_manager',
    site_manager_add: 'company:site_manager_add',
    site_manager_add_new: 'company:site_manager_add_new',
    site_manager_already_exists: 'company:site_manager_already_exists',
    site_manager_assigned: 'company:site_manager_assigned',
    site_manager_create_success: 'company:site_manager_create_success',
    site_manager_delete: 'company:site_manager_delete',
    site_manager_delete_confirm: 'company:site_manager_delete_confirm',
    site_manager_delete_registered: 'company:site_manager_delete_registered',
    site_manager_delete_success: 'company:site_manager_delete_success',
    site_manager_delete_with_site: 'company:site_manager_delete_with_site',
    site_manager_edit: 'company:site_manager_edit',
    site_manager_email: 'company:site_manager_email',
    site_manager_email_hint: 'company:site_manager_email_hint',
    site_manager_email_invalid: 'company:site_manager_email_invalid',
    site_manager_email_placeholder: 'company:site_manager_email_placeholder',
    site_manager_email_readonly: 'company:site_manager_email_readonly',
    site_manager_email_required: 'company:site_manager_email_required',
    site_manager_management: 'company:site_manager_management',
    site_manager_name: 'company:site_manager_name',
    site_manager_name_placeholder: 'company:site_manager_name_placeholder',
    site_manager_no_data: 'company:site_manager_no_data',
    site_manager_none: 'company:site_manager_none',
    site_manager_notes: 'company:site_manager_notes',
    site_manager_notes_placeholder: 'company:site_manager_notes_placeholder',
    site_manager_phone: 'company:site_manager_phone',
    site_manager_select: 'company:site_manager_select',
    site_manager_sites: 'company:site_manager_sites',
    site_manager_status: 'company:site_manager_status',
    site_manager_status_active: 'company:site_manager_status_active',
    site_manager_status_pending: 'company:site_manager_status_pending',
    site_manager_update_success: 'company:site_manager_update_success',
    site_name: 'company:site_name',
    site_name_placeholder: 'company:site_name_placeholder',
    site_name_required: 'company:site_name_required',
    site_no_data: 'company:site_no_data',
    site_telephone: 'company:site_telephone',
    site_update_success: 'company:site_update_success',
    subscription: 'company:subscription',
    subscription_active: 'company:subscription_active',
    subscription_cancel: 'company:subscription_cancel',
    subscription_cancel_confirm: 'company:subscription_cancel_confirm',
    subscription_cancel_success: 'company:subscription_cancel_success',
    subscription_canceled: 'company:subscription_canceled',
    subscription_created_at: 'company:subscription_created_at',
    subscription_custom: 'company:subscription_custom',
    subscription_d_day: 'company:subscription_d_day',
    subscription_delete_scheduled: 'company:subscription_delete_scheduled',
    subscription_device_limit: 'company:subscription_device_limit',
    subscription_device_limit_placeholder: 'company:subscription_device_limit_placeholder',
    subscription_duration_days: 'company:subscription_duration_days',
    subscription_duration_months: 'company:subscription_duration_months',
    subscription_end_date: 'company:subscription_end_date',
    subscription_expired: 'company:subscription_expired',
    subscription_history: 'company:subscription_history',
    subscription_manage: 'company:subscription_manage',
    subscription_memo: 'company:subscription_memo',
    subscription_memo_placeholder: 'company:subscription_memo_placeholder',
    subscription_no_history: 'company:subscription_no_history',
    subscription_none: 'company:subscription_none',
    subscription_period: 'company:subscription_period',
    subscription_preset: 'company:subscription_preset',
    subscription_register: 'company:subscription_register',
    subscription_renew: 'company:subscription_renew',
    subscription_save_confirm: 'company:subscription_save_confirm',
    subscription_save_success: 'company:subscription_save_success',
    subscription_settings: 'company:subscription_settings',
    subscription_settings_email_notice: 'company:subscription_settings_email_notice',
    subscription_settings_open: 'company:subscription_settings_open',
    subscription_status: 'company:subscription_status',
    subscription_view_details: 'company:subscription_view_details',
    total_companies: 'company:total_companies',
    total_devices: 'company:total_devices',
    total_sites: 'company:total_sites',
    update_site_manager_success: 'company:update_site_manager_success',
  },
  config: {
    "2ndSpanCal": 'config:2ndSpanCal',
    autoFreshAirCal: 'config:autoFreshAirCal',
    autoZeroOnStartup: 'config:autoZeroOnStartup',
    bumpInterval: 'config:bumpInterval',
    bumpTestThreshold: 'config:bumpTestThreshold',
    calibrationGasConcentration: 'config:calibrationGasConcentration',
    calibrationInterval: 'config:calibrationInterval',
    cancel: 'config:cancel',
    close: 'config:close',
    confidenceBeep: 'config:confidenceBeep',
    confidenceBeepAndGreenLightInterval: 'config:confidenceBeepAndGreenLightInterval',
    configName: 'config:configName',
    configNamePlaceholder: 'config:configNamePlaceholder',
    confirm: 'config:confirm',
    correctionFactor: 'config:correctionFactor',
    datalogInterval: 'config:datalogInterval',
    delete: 'config:delete',
    enterConfigName: 'config:enterConfigName',
    error_bleAdapterInitFailed: 'config:error_bleAdapterInitFailed',
    error_bleCharacteristicNotAvailable: 'config:error_bleCharacteristicNotAvailable',
    error_bleConnectionFailedCheckDevice: 'config:error_bleConnectionFailedCheckDevice',
    error_bleConnectionTimeout: 'config:error_bleConnectionTimeout',
    error_bleDeviceUnsupported: 'config:error_bleDeviceUnsupported',
    error_bleGattServerFailed: 'config:error_bleGattServerFailed',
    error_bleInvalidDevice: 'config:error_bleInvalidDevice',
    error_bleLiteDeviceOnly: 'config:error_bleLiteDeviceOnly',
    error_bleMethodNotSupported: 'config:error_bleMethodNotSupported',
    error_bleMiniDeviceOnly: 'config:error_bleMiniDeviceOnly',
    error_bleNoPendingResponse: 'config:error_bleNoPendingResponse',
    error_bleNotConnected: 'config:error_bleNotConnected',
    error_bleNotConnectedDesc: 'config:error_bleNotConnectedDesc',
    error_bleNotInitialized: 'config:error_bleNotInitialized',
    error_blePermissionDenied: 'config:error_blePermissionDenied',
    error_bleSelectionCancelled: 'config:error_bleSelectionCancelled',
    error_bleUnknownError: 'config:error_bleUnknownError',
    error_confidenceInterval: 'config:error_confidenceInterval',
    error_configDataInvalid: 'config:error_configDataInvalid',
    error_configSensorTypeMismatch: 'config:error_configSensorTypeMismatch',
    error_configSensorTypeMismatchDesc: 'config:error_configSensorTypeMismatchDesc',
    error_datalogInterval: 'config:error_datalogInterval',
    error_deviceInfoInvalid: 'config:error_deviceInfoInvalid',
    error_highAlarmMustExceedLowAlarm: 'config:error_highAlarmMustExceedLowAlarm',
    error_intelliflashInterval: 'config:error_intelliflashInterval',
    error_invalidDeviceType: 'config:error_invalidDeviceType',
    error_invalidFileFormat: 'config:error_invalidFileFormat',
    error_invalidMiniDeviceType: 'config:error_invalidMiniDeviceType',
    error_invalidNumber: 'config:error_invalidNumber',
    error_invalidRange: 'config:error_invalidRange',
    error_invalidTimestamp: 'config:error_invalidTimestamp',
    error_invalidVersion: 'config:error_invalidVersion',
    error_locationNameInvalid: 'config:error_locationNameInvalid',
    error_locationNameLength: 'config:error_locationNameLength',
    error_missingDeviceType: 'config:error_missingDeviceType',
    error_missingRequiredData: 'config:error_missingRequiredData',
    error_rangeValue: 'config:error_rangeValue',
    error_rangeValues: 'config:error_rangeValues',
    error_sensorCountMismatch: 'config:error_sensorCountMismatch',
    error_sensorCountMismatchDesc: 'config:error_sensorCountMismatchDesc',
    error_sensorTypeMismatch: 'config:error_sensorTypeMismatch',
    error_sensorTypeMismatchDesc: 'config:error_sensorTypeMismatchDesc',
    error_serialNoPendingResponse: 'config:error_serialNoPendingResponse',
    error_serialPortNotAvailable: 'config:error_serialPortNotAvailable',
    error_startupMessageInvalid: 'config:error_startupMessageInvalid',
    error_startupMessageLength: 'config:error_startupMessageLength',
    error_unknownError: 'config:error_unknownError',
    error_valueRequired: 'config:error_valueRequired',
    error_workerNameInvalid: 'config:error_workerNameInvalid',
    error_workerNameLength: 'config:error_workerNameLength',
    gasUnit: 'config:gasUnit',
    general: 'config:general',
    greenLight: 'config:greenLight',
    highAlarm: 'config:highAlarm',
    hint_bumpInterval: 'config:hint_bumpInterval',
    hint_bumpTestThreshold: 'config:hint_bumpTestThreshold',
    hint_calibrationGasConc: 'config:hint_calibrationGasConc',
    hint_calibrationInterval: 'config:hint_calibrationInterval',
    hint_confidenceInterval: 'config:hint_confidenceInterval',
    hint_customLel: 'config:hint_customLel',
    hint_datalogInterval: 'config:hint_datalogInterval',
    hint_highAlarm: 'config:hint_highAlarm',
    hint_locationName: 'config:hint_locationName',
    hint_lowAlarm: 'config:hint_lowAlarm',
    hint_startupMessage: 'config:hint_startupMessage',
    hint_stelAlarm: 'config:hint_stelAlarm',
    hint_stelPeriod: 'config:hint_stelPeriod',
    hint_twaAlarm: 'config:hint_twaAlarm',
    hint_twaPeriod: 'config:hint_twaPeriod',
    hint_workerName: 'config:hint_workerName',
    latchingAlarm: 'config:latchingAlarm',
    lel_CF_Index: 'config:lel_CF_Index',
    load: 'config:load',
    loadDefaultSettings: 'config:loadDefaultSettings',
    loadFromStorage: 'config:loadFromStorage',
    locationName: 'config:locationName',
    lowAlarm: 'config:lowAlarm',
    lowAlarmAck: 'config:lowAlarmAck',
    msg_configLoadFailed: 'config:msg_configLoadFailed',
    msg_configLoaded: 'config:msg_configLoaded',
    msg_configNameExists: 'config:msg_configNameExists',
    msg_configNameExistsDesc: 'config:msg_configNameExistsDesc',
    msg_configSaveFailed: 'config:msg_configSaveFailed',
    msg_configSaved: 'config:msg_configSaved',
    msg_confirmDeleteConfig: 'config:msg_confirmDeleteConfig',
    msg_confirmSaveSettings: 'config:msg_confirmSaveSettings',
    msg_connectCorrectDevice: 'config:msg_connectCorrectDevice',
    msg_connectionLost: 'config:msg_connectionLost',
    msg_cradleConnectFailed: 'config:msg_cradleConnectFailed',
    msg_cradleConnectFailedDesc: 'config:msg_cradleConnectFailedDesc',
    msg_defaultValueLoaded: 'config:msg_defaultValueLoaded',
    msg_defaultValueLoading: 'config:msg_defaultValueLoading',
    msg_defaultValueLoadingDesc: 'config:msg_defaultValueLoadingDesc',
    msg_defaultValueLoadingFailed: 'config:msg_defaultValueLoadingFailed',
    msg_defaultValueLoadingFailedDesc: 'config:msg_defaultValueLoadingFailedDesc',
    msg_fileSaveFailed: 'config:msg_fileSaveFailed',
    msg_fileValidationFailed: 'config:msg_fileValidationFailed',
    msg_miniDefaultValueLoaded: 'config:msg_miniDefaultValueLoaded',
    msg_noSavedConfigurations: 'config:msg_noSavedConfigurations',
    msg_noSavedConfigurationsDesc: 'config:msg_noSavedConfigurationsDesc',
    msg_sensorConstraintsLoadFailed: 'config:msg_sensorConstraintsLoadFailed',
    msg_sensorDisabledFieldsLocked: 'config:msg_sensorDisabledFieldsLocked',
    msg_sensorInfoLoadFailed: 'config:msg_sensorInfoLoadFailed',
    msg_serialDeviceNoResponse: 'config:msg_serialDeviceNoResponse',
    msg_serialNotSupported: 'config:msg_serialNotSupported',
    msg_serialPortOpenFailed: 'config:msg_serialPortOpenFailed',
    msg_settingsDataMismatch: 'config:msg_settingsDataMismatch',
    msg_settingsHasErrors: 'config:msg_settingsHasErrors',
    msg_settingsSaveFailed: 'config:msg_settingsSaveFailed',
    msg_settingsSaveSuccess: 'config:msg_settingsSaveSuccess',
    msg_settingsSavedFailed: 'config:msg_settingsSavedFailed',
    msg_settingsSavedSuccessfully: 'config:msg_settingsSavedSuccessfully',
    msg_settingsSaving: 'config:msg_settingsSaving',
    msg_unknownDevice: 'config:msg_unknownDevice',
    msg_unknownError: 'config:msg_unknownError',
    no: 'config:no',
    noSavedConfigurations: 'config:noSavedConfigurations',
    overwrite: 'config:overwrite',
    placeholder_locationName: 'config:placeholder_locationName',
    placeholder_startupMessage: 'config:placeholder_startupMessage',
    placeholder_workerName: 'config:placeholder_workerName',
    rangeSeparator: 'config:rangeSeparator',
    safeMode: 'config:safeMode',
    save: 'config:save',
    saveSettings: 'config:saveSettings',
    saveToStorage: 'config:saveToStorage',
    savedConfigurations: 'config:savedConfigurations',
    sensorDisable: 'config:sensorDisable',
    startupMessage: 'config:startupMessage',
    stealthMode: 'config:stealthMode',
    stelAlarm: 'config:stelAlarm',
    stelPeriod: 'config:stelPeriod',
    twaAlarm: 'config:twaAlarm',
    twaPeriod: 'config:twaPeriod',
    vol_for_50_lel_ch4: 'config:vol_for_50_lel_ch4',
    warning_nonEnglishLCD: 'config:warning_nonEnglishLCD',
    warning_nonEnglishLocationName: 'config:warning_nonEnglishLocationName',
    warning_nonEnglishWorkerName: 'config:warning_nonEnglishWorkerName',
    workerName: 'config:workerName',
  },
  datalog: {
    batchDownloadCancelled: 'datalog:batchDownloadCancelled',
    batchSomeDownloadsFailed: 'datalog:batchSomeDownloadsFailed',
    cancel: 'datalog:cancel',
    certificateGenerationFailed: 'datalog:certificateGenerationFailed',
    connected: 'datalog:connected',
    connectingBluetooth: 'datalog:connectingBluetooth',
    connectingCradle: 'datalog:connectingCradle',
    dataLoading: 'datalog:dataLoading',
    days_requested_required_for_gas: 'datalog:days_requested_required_for_gas',
    deviceNotInSite: 'datalog:deviceNotInSite',
    disconnect: 'datalog:disconnect',
    downloadLog: 'datalog:downloadLog',
    downloadTimeEstimate: 'datalog:downloadTimeEstimate',
    downloadingDataDeleted: 'datalog:downloadingDataDeleted',
    downloadingLogType: 'datalog:downloadingLogType',
    excelGenerationFailed: 'datalog:excelGenerationFailed',
    hours: 'datalog:hours',
    invalid_chunk_data_format: 'datalog:invalid_chunk_data_format',
    logDataSaved: 'datalog:logDataSaved',
    logDownloadCancelled: 'datalog:logDownloadCancelled',
    logDownloadComplete: 'datalog:logDownloadComplete',
    logDownloadFailed: 'datalog:logDownloadFailed',
    logProcessingTitle: 'datalog:logProcessingTitle',
    logRequestContinuePrompt: 'datalog:logRequestContinuePrompt',
    logRequestEstimatedDurationTitle: 'datalog:logRequestEstimatedDurationTitle',
    logRequestFailed: 'datalog:logRequestFailed',
    logRequestFullLogDownloadBodyLite: 'datalog:logRequestFullLogDownloadBodyLite',
    logRequestFullLogDownloadDescription: 'datalog:logRequestFullLogDownloadDescription',
    logTypeComplete: 'datalog:logTypeComplete',
    log_incomplete_missing_chunks: 'datalog:log_incomplete_missing_chunks',
    log_info_not_found: 'datalog:log_info_not_found',
    log_processing: 'datalog:log_processing',
    noData: 'datalog:noData',
    noDataInPeriod: 'datalog:noDataInPeriod',
    noDataMessage: 'datalog:noDataMessage',
    noRegisteredDevices: 'datalog:noRegisteredDevices',
    no_chunks_for_log: 'datalog:no_chunks_for_log',
    no_valid_data_extracted: 'datalog:no_valid_data_extracted',
    pdfGenerated: 'datalog:pdfGenerated',
    pdfGenerationFailed: 'datalog:pdfGenerationFailed',
    pleaseSelectSensor: 'datalog:pleaseSelectSensor',
    preparingDatalogRequest: 'datalog:preparingDatalogRequest',
    registeredDevices: 'datalog:registeredDevices',
    sensor: 'datalog:sensor',
    serial: 'datalog:serial',
    temperature: 'datalog:temperature',
    time: 'datalog:time',
    timeline: 'datalog:timeline',
    timelineBle: 'datalog:timelineBle',
    timelineCharging: 'datalog:timelineCharging',
    timelineOperating: 'datalog:timelineOperating',
  },
  device: {
    bluetooth: 'device:bluetooth',
    bluetoothConnected: 'device:bluetoothConnected',
    bluetoothFailed: 'device:bluetoothFailed',
    bluetoothFailedDesc: 'device:bluetoothFailedDesc',
    connectingBluetooth: 'device:connectingBluetooth',
    connectingCradle: 'device:connectingCradle',
    cradle: 'device:cradle',
    cradleConnect: 'device:cradleConnect',
    cradleConnected: 'device:cradleConnected',
    cradleConnectionFailed: 'device:cradleConnectionFailed',
    cradleConnectionFailedDesc: 'device:cradleConnectionFailedDesc',
    device: 'device:device',
    deviceInfoFailed: 'device:deviceInfoFailed',
    deviceInfoFailedDesc: 'device:deviceInfoFailedDesc',
    deviceInfoRefreshed: 'device:deviceInfoRefreshed',
    deviceLoaded: 'device:deviceLoaded',
    disconnectFailed: 'device:disconnectFailed',
    disconnected: 'device:disconnected',
    disconnectedDesc: 'device:disconnectedDesc',
    disconnecting: 'device:disconnecting',
    invalid_device_id: 'device:invalid_device_id',
    invalid_timestamp_format: 'device:invalid_timestamp_format',
    loadFailed: 'device:loadFailed',
    loadFailedDesc: 'device:loadFailedDesc',
    loadingDefaultConfig: 'device:loadingDefaultConfig',
    loadingDeviceFromCradle: 'device:loadingDeviceFromCradle',
    max_devices_exceeded: 'device:max_devices_exceeded',
    max_devices_exceeded_desc: 'device:max_devices_exceeded_desc',
    max_devices_exceeded_title: 'device:max_devices_exceeded_title',
    notConnected: 'device:notConnected',
    refreshFailed: 'device:refreshFailed',
    refreshingDeviceInfo: 'device:refreshingDeviceInfo',
    savingConfig: 'device:savingConfig',
    scanFailed: 'device:scanFailed',
    serialNumber: 'device:serialNumber',
    serialNumberMissing: 'device:serialNumberMissing',
  },
  guide: {
    allowed_email_invite_company: 'guide:allowed_email_invite_company',
    allowed_email_invite_device_limit: 'guide:allowed_email_invite_device_limit',
    allowed_email_invite_duration: 'guide:allowed_email_invite_duration',
    allowed_email_invite_email: 'guide:allowed_email_invite_email',
    allowed_email_invite_intro: 'guide:allowed_email_invite_intro',
    allowed_email_invite_memo: 'guide:allowed_email_invite_memo',
    allowed_emails_add: 'guide:allowed_emails_add',
    allowed_emails_intro: 'guide:allowed_emails_intro',
    allowed_emails_list: 'guide:allowed_emails_list',
    allowed_emails_summary: 'guide:allowed_emails_summary',
    back: 'guide:back',
    close: 'guide:close',
    company_info: 'guide:company_info',
    company_info_edit: 'guide:company_info_edit',
    company_intro: 'guide:company_intro',
    company_manager_edit: 'guide:company_manager_edit',
    company_manager_info: 'guide:company_manager_info',
    company_site_list: 'guide:company_site_list',
    company_summary: 'guide:company_summary',
    config_connect_device: 'guide:config_connect_device',
    config_lite_intro: 'guide:config_lite_intro',
    config_load_default: 'guide:config_load_default',
    config_load_from_storage: 'guide:config_load_from_storage',
    config_mini_intro: 'guide:config_mini_intro',
    config_save_settings: 'guide:config_save_settings',
    config_save_to_storage: 'guide:config_save_to_storage',
    create_site_button: 'guide:create_site_button',
    dashboard_device_status: 'guide:dashboard_device_status',
    datalog_import_log_button: 'guide:datalog_import_log_button',
    datalog_import_log_card: 'guide:datalog_import_log_card',
    datalog_log_area: 'guide:datalog_log_area',
    datalog_registered_devices: 'guide:datalog_registered_devices',
    device_configurator: 'guide:device_configurator',
    device_delete: 'guide:device_delete',
    device_detail_expand: 'guide:device_detail_expand',
    device_download_excel: 'guide:device_download_excel',
    device_edit: 'guide:device_edit',
    device_reassign: 'guide:device_reassign',
    device_register: 'guide:device_register',
    last: 'guide:last',
    login_email: 'guide:login_email',
    login_password: 'guide:login_password',
    login_submit: 'guide:login_submit',
    monitoring_device_detail: 'guide:monitoring_device_detail',
    monitoring_device_detail_btn: 'guide:monitoring_device_detail_btn',
    monitoring_device_list: 'guide:monitoring_device_list',
    monitoring_intro: 'guide:monitoring_intro',
    monitoring_map: 'guide:monitoring_map',
    monitoring_push: 'guide:monitoring_push',
    monitoring_push_more: 'guide:monitoring_push_more',
    next: 'guide:next',
    next_with_progress: 'guide:next_with_progress',
    online_summary: 'guide:online_summary',
    playback_data_trend: 'guide:playback_data_trend',
    playback_device_status: 'guide:playback_device_status',
    playback_map: 'guide:playback_map',
    playback_timeline: 'guide:playback_timeline',
    "register-send-link": 'guide:register-send-link',
    register_email: 'guide:register_email',
    register_password: 'guide:register_password',
    register_submit: 'guide:register_submit',
    registered_device_list: 'guide:registered_device_list',
    report_download: 'guide:report_download',
    sample_device: 'guide:sample_device',
    sample_site_manager: 'guide:sample_site_manager',
    site_delete: 'guide:site_delete',
    site_device_list: 'guide:site_device_list',
    site_device_status: 'guide:site_device_status',
    site_edit: 'guide:site_edit',
    site_info: 'guide:site_info',
    site_info_edit: 'guide:site_info_edit',
    site_manager_add: 'guide:site_manager_add',
    site_manager_card: 'guide:site_manager_card',
    site_manager_delete: 'guide:site_manager_delete',
    site_manager_edit: 'guide:site_manager_edit',
    site_manager_info: 'guide:site_manager_info',
    site_manager_info_edit: 'guide:site_manager_info_edit',
    site_show_devices: 'guide:site_show_devices',
    site_summary: 'guide:site_summary',
    skip: 'guide:skip',
    subscription_device_limit: 'guide:subscription_device_limit',
    subscription_duration_preset: 'guide:subscription_duration_preset',
    subscription_end_date: 'guide:subscription_end_date',
    subscription_intro: 'guide:subscription_intro',
    subscription_memo: 'guide:subscription_memo',
    subscription_save: 'guide:subscription_save',
    view: 'guide:view',
  },
  monitoring: {
    device_not_found: 'monitoring:device_not_found',
    get_history_success: 'monitoring:get_history_success',
    invalid_date_format: 'monitoring:invalid_date_format',
    monitoringRequestFailed: 'monitoring:monitoringRequestFailed',
    no_accessible_companies: 'monitoring:no_accessible_companies',
    no_accessible_sites: 'monitoring:no_accessible_sites',
    no_company_assigned: 'monitoring:no_company_assigned',
    no_devices_found: 'monitoring:no_devices_found',
    no_monitoring_permission: 'monitoring:no_monitoring_permission',
    no_site_access: 'monitoring:no_site_access',
    no_sites_assigned: 'monitoring:no_sites_assigned',
    playback_map_waiting: 'monitoring:playback_map_waiting',
    playback_no_data: 'monitoring:playback_no_data',
    playback_no_location: 'monitoring:playback_no_location',
    playback_query: 'monitoring:playback_query',
    playback_querying: 'monitoring:playback_querying',
    playback_select_another_date: 'monitoring:playback_select_another_date',
    playback_select_date: 'monitoring:playback_select_date',
    playback_select_device_and_date: 'monitoring:playback_select_device_and_date',
    unsupported_device_type: 'monitoring:unsupported_device_type',
  },
  site: {
    action: 'site:action',
    allCompanies: 'site:allCompanies',
    allDevices: 'site:allDevices',
    allSites: 'site:allSites',
    areaCreated: 'site:areaCreated',
    areaDeleted: 'site:areaDeleted',
    areaDrawCancelled: 'site:areaDrawCancelled',
    areaDrawingInitFailed: 'site:areaDrawingInitFailed',
    areaGeoLocationFailed: 'site:areaGeoLocationFailed',
    areaGeoPlaceFailed: 'site:areaGeoPlaceFailed',
    areaMapsLoadFailed: 'site:areaMapsLoadFailed',
    areaMapsLoading: 'site:areaMapsLoading',
    areaMovedTo: 'site:areaMovedTo',
    areaNameShapeRequired: 'site:areaNameShapeRequired',
    areaSetting: 'site:areaSetting',
    assign_site_manager_success: 'site:assign_site_manager_success',
    calibrationDueDate: 'site:calibrationDueDate',
    cancel: 'site:cancel',
    companyManagerRequired: 'site:companyManagerRequired',
    confirmDeleteArea: 'site:confirmDeleteArea',
    confirmDeleteDevice: 'site:confirmDeleteDevice',
    connected: 'site:connected',
    create_site_success: 'site:create_site_success',
    delete: 'site:delete',
    delete_site_success: 'site:delete_site_success',
    device: 'site:device',
    deviceAlreadyRegistered: 'site:deviceAlreadyRegistered',
    deviceBelongsToAnotherSite: 'site:deviceBelongsToAnotherSite',
    deviceBelongsToAnotherSiteDesc: 'site:deviceBelongsToAnotherSiteDesc',
    deviceBelongsToOtherCompany: 'site:deviceBelongsToOtherCompany',
    deviceBelongsToOtherCompanyDesc: 'site:deviceBelongsToOtherCompanyDesc',
    deviceBelongsToUnmanagedSite: 'site:deviceBelongsToUnmanagedSite',
    deviceBelongsToUnmanagedSiteDesc: 'site:deviceBelongsToUnmanagedSiteDesc',
    deviceConfigFailed: 'site:deviceConfigFailed',
    deviceDeleteFailed: 'site:deviceDeleteFailed',
    deviceDeleted: 'site:deviceDeleted',
    deviceDeleting: 'site:deviceDeleting',
    deviceEditFailed: 'site:deviceEditFailed',
    deviceInfo: 'site:deviceInfo',
    deviceInfoEdit: 'site:deviceInfoEdit',
    deviceInfoEdited: 'site:deviceInfoEdited',
    deviceInfoMissing: 'site:deviceInfoMissing',
    deviceInfoUpdate: 'site:deviceInfoUpdate',
    deviceInfoUpdateDescription: 'site:deviceInfoUpdateDescription',
    deviceInfoUpdated: 'site:deviceInfoUpdated',
    deviceInfoUpdating: 'site:deviceInfoUpdating',
    deviceRegistered: 'site:deviceRegistered',
    deviceRegistering: 'site:deviceRegistering',
    deviceRegistrationFailed: 'site:deviceRegistrationFailed',
    deviceType: 'site:deviceType',
    disconnected: 'site:disconnected',
    edit: 'site:edit',
    exampleLatitude: 'site:exampleLatitude',
    exampleLongitude: 'site:exampleLongitude',
    fixedLatitude: 'site:fixedLatitude',
    fixedLongitude: 'site:fixedLongitude',
    get_all_sites_success: 'site:get_all_sites_success',
    get_site_info_success: 'site:get_site_info_success',
    get_site_managers_success: 'site:get_site_managers_success',
    get_sites_failed: 'site:get_sites_failed',
    get_sites_success: 'site:get_sites_success',
    get_user_sites_success: 'site:get_user_sites_success',
    lastConnect: 'site:lastConnect',
    loading: 'site:loading',
    manager_already_assigned: 'site:manager_already_assigned',
    manager_not_found: 'site:manager_not_found',
    noRegisteredDevices: 'site:noRegisteredDevices',
    noSelectOptions: 'site:noSelectOptions',
    no_company_assigned: 'site:no_company_assigned',
    no_site_access: 'site:no_site_access',
    no_sites_assigned: 'site:no_sites_assigned',
    only_own_company: 'site:only_own_company',
    only_own_site: 'site:only_own_site',
    only_site_manager_role: 'site:only_site_manager_role',
    registerDevice: 'site:registerDevice',
    registeredDevices: 'site:registeredDevices',
    registering: 'site:registering',
    remove_site_manager_success: 'site:remove_site_manager_success',
    save: 'site:save',
    selectDevice: 'site:selectDevice',
    selectSite: 'site:selectSite',
    sensorDisabled: 'site:sensorDisabled',
    serial: 'site:serial',
    serialNumber: 'site:serialNumber',
    site: 'site:site',
    site_not_found: 'site:site_not_found',
    status: 'site:status',
    totalDevices: 'site:totalDevices',
    update_site_success: 'site:update_site_success',
    user_not_found: 'site:user_not_found',
  },
};
